module.exports = __webpack_public_path__ + "img/sq6m_02.b9dd1f14.jpg";